import IntersectionObserverAdmin from 'intersection-observer-admin';
const intersectionObserver = new IntersectionObserverAdmin();
export default function useIntersectionObserver() {
    return {
        intersectionObserver,
    };
}
